import { Controller } from "@hotwired/stimulus"

// Masks input as dd/mm/yyyy (digits only, slashes inserted automatically).
export default class extends Controller {
  connect() {
    this.boundFormat = this.format.bind(this)
    this.boundPaste = () => setTimeout(this.boundFormat, 0)
    this.element.addEventListener("input", this.boundFormat)
    this.element.addEventListener("paste", this.boundPaste)
  }

  disconnect() {
    this.element.removeEventListener("input", this.boundFormat)
    this.element.removeEventListener("paste", this.boundPaste)
  }

  format() {
    const digits = this.element.value.replace(/\D/g, "").slice(0, 8)
    let out = ""
    if (digits.length >= 1) out = digits.slice(0, 2)
    if (digits.length >= 3) out += "/" + digits.slice(2, 4)
    if (digits.length >= 5) out += "/" + digits.slice(4, 8)
    this.element.value = out
  }
}
